module.exports = __webpack_public_path__ + "img/right_2.451a1fba.jpg";